import Joi from "joi";

export const assetActiontypeSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
});
